export default __webpack_public_path__ + "static/media/August2014.0fd4e77d.png";